import axiosClient from "./axiosClient";
import ROUTES from "./api_routes";

async function sponsors() {
  return axiosClient.get(ROUTES.GET_SPONSORS);
}
    
const SponsorsClient = {
  sponsors
};

export default SponsorsClient; 